export class Office {
    constructor(
        public id: number,
        public name: string,
        public phone: string,
        public fax: string,
        public location: string,
        public address: string
    ) { }
}